import { Box, Button } from "@mui/material"
import { Create } from "./Create"
import { env } from "../../../../../core/Env"
import { rqx } from "../../../../../core/request/API"
import { useContext, useEffect } from "react"
import { ToolContext } from "../../../../../core/context/ToolContext"
import { List } from './List'

export const Membership = () => {
	const { setup_state, tool_state } = useContext(ToolContext)
	const { __SESSION } = tool_state
	const { memberList, memberLoader, memberHasMore, memberPage, memberModals, memberMethod } = setup_state

	const handleCreateMemberhip = async () => {
		memberModals.set((p) => ({ ...p, form: true }))
		memberMethod.set('create')
	}

	const __init = async (pageToFetch) => {
		if (pageToFetch === 1) {
			memberLoader.set((p) => ({ ...p, list: true }))
        }
        const read = await rqx.get(`<<tool>>/${env()}/membership/read_list`, {company_id: __SESSION.data.uaccess[0].company_id, page: pageToFetch, limit: 10 })
        if (read.length < 10) {
            memberHasMore.set(false)
        }else{
            memberHasMore.set(true)
        }
        if (pageToFetch === 1) {
            memberList.set(read)
        }else{
            memberList.set((p) => [...p, ...read])
        }
        memberPage.set(pageToFetch + 1)
        memberLoader.set((p) => ({ ...p, list: false }))
	}
	
	const loadMoreData = () => {
        __init(memberPage.data)
    }

	useEffect(() => {
		__init(1);
		// eslint-disable-next-line
	}, [])
   
	return (
		<Box height="100%" width="100%" display="flex" flexDirection="column" className="overflowY" gap="24px">
			<Box display="flex" my={1} justifyContent="space-between" alignItems="center">
				<Box fontSize={20} fontWeight={700}>Membership List</Box>
				<Button variant="contained" sx={{ fontSize: 14, fontWeight: 400 }} onClick={handleCreateMemberhip}>Add Membership</Button>
			</Box>
			<List __init={__init} loadMoreData={loadMoreData}/>
			{
				memberModals.data.form &&
					<Create __init={__init}/>
			}
		</Box>
	)
}
